import { render } from "./ProductsCarousel.vue?vue&type=template&id=12f4330e"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js"

import "./ProductsCarousel.vue?vue&type=style&index=0&id=12f4330e&lang=css"
script.render = render

export default script